import { useContext } from 'react';

import { ServicesContext } from '../context';

export const useServices = () => {
  const services = useContext(ServicesContext);

  if (!services) {
    throw new Error('Services context is empty');
  }

  return services;
};
